import Cookies from 'js-cookie';

const CookieStorageBuilder = (cookies) => ({
  setCookie: (key, value, options) =>
    cookies.set(key, value, {
      path: '/',
      domain: '',
      secure: process.env.NODE_ENV === 'production' ? true : false,
      httpOnly: false,
      sameSite: 'Lax',
      ...options
    }),
  getCookie: (key) => cookies.get(key),
  removeCookie: (key) => cookies.remove(key),
  clearAllCookies: () => {
    const allCookies = cookies.get();

    Object.keys(allCookies).forEach((cookieName) => {
      cookies.remove(cookieName);
    });
  },
  dotremoveCookie: (key, domain) => cookies.remove(key, { domain: domain ?? '' })
});

export const cookieStorage = CookieStorageBuilder(Cookies);

const COOKIE_BASE_NAME = '4d-vsc';

export const COOKIE_ACCESS_TOKEN = `${COOKIE_BASE_NAME}_acst`;
export const REFRESH_ACCESS_TOKEN = `${COOKIE_BASE_NAME}_rcst`;
